export default __webpack_public_path__ + "static/media/list_main_12_2.1a96d683.jpg";